//****VARIABLES****
//CUSTOM//*********************************

//Cache
let cache = {
  sessionID: "",
  productitle: "Custom Framing",
  productid: 40290702524468,
  details: {
    type: {
      media: 'digital',//digital, object, frameonly
      additionalmedia: null,
      additionalmediatype: null,
      service: 'printandframe',
      placeholder: null
    },
    dims: {
      width: 0,
      height: 0
    },
    units: "in",
    paper: {
      printmethod: "Giclée",
      type: "Cotton Rag 310gsm",
      size: {
        printarea: {
          in: {
            width: 0,
            height: 0
          },
          mm: {
            width: 0,
            height: 0
          }
        },
        border: {
          in: 0,
          mm: 0
        },
      }
    },
    frame: {
      moulding: {
        id: 'kingston',
        option1: '7.8mm(0.31in)',
        option2: 'Matt Black'
      },
      mounting: {
        type: 'none',
        depth: {
          in: 0,
          mm: 0
        }
      },
      windowmount: {
        id: 'white/white',
        size: {
          in: 0,
          mm: 0
        }
      }//{ colour: string, type: string, sizing: {type: classic/oversize/narrow, size: {in: num, mm: num}} }
    },
    tiles: [],
    
  },
};

//Declare options for right menu
let designobj = {
  options: [
    {
      name: "Art Size",
      icon: svgsize,
      description:
        '',//"Enter the width and height below, the ratio of the file you have uploaded will be automatically calculated when you change either dimension.",
      variants: [
        {
          name: "Units",
          id: "units",
          type: "select",
          options: [
            { name: 'Inches', value: 'in' },
            { name: 'Millimetres', value: 'mm' }
          ]
        },
        {
          name: "Print Size",
          id: "size",
          type: "sizing",
          variations: [
            {
              name: "Width",
              id: "width",
              type: 'text'
            },
            {
              name: "Height",
              id: "height",
              type: 'text'
            },
          ],
        },
      ],
    },
    {
      name: "Framing",
      icon: svgframe,
      description: "Choose from our selection of frame finishes.",
      variants: [
        {
          name: 'Frame Options',
          id: 'mapstyle',
          type: 'frameselect',
          variations: [
            {
              name: 'Standard',
              id: 'mapstyle',
              options: [
                { name: 'Black', url: 'mapbox://styles/tman16/ck36i7f0s5ra71cm7biergcnw', image: "https://app.printframeco.com/e24df950-7205-43ab-b492-56aa2d3da2d7/Black.jpg" },
                { name: 'Classic W/B', url: "mapbox://styles/tman16/cjz88vqz12k6t1cr6smf1otoy", image: "https://app.printframeco.com/0eb5a9b3-5a28-4e3e-8e7b-89a5d40104e8/White.jpg" },
                { name: 'Classic Red', url: "mapbox://styles/tman16/ck37otgw76tyx1cm7hn8jsni4", image: "https://app.printframeco.com/f22064aa-21e9-4842-b8c9-b5aec1d83003/Red.jpg" },
                { name: 'Classic Blue', url: "mapbox://styles/tman16/ck3w3mgeb3o151cltw4f702w0", image: "https://app.printframeco.com/ac812cba-96f0-44f4-8b50-385fc19023b7/Blue.jpg" },
                { name: 'Classic Green', url: "mapbox://styles/tman16/ck4o2jx9h0jsv1cruiii969fi", image: "https://app.printframeco.com/10095709-cc80-4334-b193-1b6aa8d6407b/Green.jpg" },
                { name: 'Classic Grey', url: "mapbox://styles/tman16/ck4o3vfwa6rmh1cur5jq4yhub", image: "https://app.printframeco.com/d088f6b2-1f0a-43bb-93c1-2d730b4df215/Grey.jpg" },
                { name: 'Classic Orange', url: "mapbox://styles/tman16/ck4o3zbyo4vfk1cms67942ptk", image: "https://app.printframeco.com/4d75a524-7d13-46c3-8d93-2dc7578ed82b/Orange.jpg" },
                { name: 'Nautical', url: "mapbox://styles/tman16/ck4ou2xv709wn1co6zi232ku4", image: "https://app.printframeco.com/9d248a39-91c7-4a43-b0f5-3a6058c0fc39/Nautical.jpg" },
                { name: 'Urban', url: "mapbox://styles/tman16/ck5yk0u4j01zo1io0pche8ioa", image: "https://app.printframeco.com/562ad0ba-705b-4939-bfe7-c6083a964f93/Urban.jpg" },
                { name: 'Streets', url: "mapbox://styles/tman16/ck3y8f50p1sos1cpnheob2xkw", image: "https://app.printframeco.com/1f08f7c7-37a8-4324-ba9b-aaf8cc2ead49/Streets.jpg" },
                { name: 'Satellite', url: "mapbox://styles/tman16/ck0i0d0fa0a7h1dmdgop0zgr1", image: "https://app.printframeco.com/4bf1d56c-a9a4-4730-b805-cc2575d738fa/Satellite.jpg" },
                { name: 'Pop', url: "mapbox://styles/tman16/ck5n7ihw15fbk1io9ay9zghb5", image: "https://app.printframeco.com/459a5852-5b1c-4f53-89bc-8a98bf3c203a/Pop.jpg" },
                { name: 'Maritime', url: 'mapbox://styles/tman16/ck5spo97o3e7u1in3r5f0om68', image: "https://app.printframeco.com/b3156fa9-84a0-40a1-ba87-08bcf14b8db7/Maritime.jpg" },
                { name: 'Mondrian', url: "mapbox://styles/tman16/ck5uaabwt01401ilorq94bgjy", image: "https://app.printframeco.com/7a9cf423-5365-4c71-83d1-697d02df3426/Mondrian.jpg" },
                { name: 'Outdoors', url: "mapbox://styles/tman16/ck7g4djj1025w1io4djfvus0o", image: "https://app.printframeco.com/a96fb794-1d61-4593-bc3a-da2a73ae56e6/Outdoors.jpg" },
                { name: 'Pastel', url: "mapbox://styles/tman16/ckmzpsx1b0djz17p0axe30hn7", image: "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/Pastel.png?v=1617393196" },
                { name: 'Tricolore', url: "mapbox://styles/tman16/ckbcuao6e1kdu1ildxzeg3wdw", image: "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/Tricolore.jpg?v=1621200524" },
              ]
            },
          ]
        },
      ],
    },
    {
      name: "Art Type",
      icon: svglayout,
      description:
        "Choose what you would like framed and the service option.",
      variants: [
        {
          name: "What Are You Framing",
          id: "arttype",
          type: "service",
          variations: [
            {
              name: 'Digital Upload',
              icon: `https://cdn.framebridge.com/production/art_type_tiles/2/icons/original/prints_vector.svg?1599587696`,
              value: 'digital',
              description: `You will upload a digital file/image for us to print and frame.`,
              services: [
                { name: 'Print & Frame', value: 'printandframe', description: `Upload your digital file making sure it is the highest resolution version possible, our software will let you know the best size to print at but you are welcome to edit this yourself. Once complete we will print, frame and post you your design ready to hang.` }
              ]
            },
            {
              name: 'Art, Prints and Posters',
              icon: `https://cdn.framebridge.com/production/art_type_tiles/2/icons/original/prints_vector.svg?1599587696`,
              value: 'art',
              description: `We'll recommend specific frames depending whether your art is on paper or canvas.`,
              placeholders: [
                { type: 'canvas', url: `https://res.cloudinary.com/dmoqthczr/image/upload/v1673237722/Custom%20Framing%20-%20Select%20Examples/example-art-canvas-1_jgepta.jpg`},
                { type: 'canvas', url: `https://res.cloudinary.com/dmoqthczr/image/upload/v1673237722/Custom%20Framing%20-%20Select%20Examples/example-art-canvas-2_puf6sj.jpg`},
                { type: 'canvas', url: `https://res.cloudinary.com/dmoqthczr/image/upload/v1673237722/Custom%20Framing%20-%20Select%20Examples/example-art-canvas-3_fobywb.jpg`},
                { type: 'paper', url: `https://res.cloudinary.com/dmoqthczr/image/upload/v1673237722/Custom%20Framing%20-%20Select%20Examples/example-art-paper-1_gfn1ru.jpg`},
              ],
              additionalselect: [
                {name: 'Paper', value: 'paper'},
                {name: 'Canvas', value: 'canvas', extra: [{name: 'Stretched Canvas', value: 'stretchedcanvas', icon: `https://www.framebridge.com/_nuxt/img/canvas-stretched.5996639.jpg`},{name: 'Canvas Sheet', value: 'canvassheet', icon: `https://www.framebridge.com/_nuxt/img/canvas-unstretched.61448a1.jpg`}]}
              ],
              services: [
                { name: 'Frame Only', value: 'frameonly', description: `We will send you a custom frame taylored to your specific measures, we recommend that you follow our measuring guide below.`, url: `https://app.printframeco.com/5ff6a0e8-0f8e-403a-bed2-f0fac3570cbb/FrameMadeToMeasure.jpg`, validation: [{additionalmedia: 'paper'}] },
                { name: 'Frame In Store - Drop Off & Collection', value: 'instore', description: `Drop your art in at our store. Our experts will meticulously measure your piece when we receive it (down to the teeniest fraction of an inch) and professionally frame it.`, url: `https://app.printframeco.com/7d429f87-2a94-4dcc-b3d1-ab9c38c2cae2/DropOff.jpg` }
              ]
            },
            {
              name: 'Documents & Items On Paper',
              icon: `https://cdn.framebridge.com/production/art_type_tiles/2/icons/original/prints_vector.svg?1599587696`,
              value: 'document',
              description: `We'll recommend specific frames.`,
              services: [
                { name: 'Frame Only', value: 'frameonly', description: `We will send you a custom frame taylored to your specific measurements.`, },
                { name: 'Frame In Store - Drop Off & Collection', value: 'instore', description: `Drop your art in at our store. Our experts will meticulously measure your piece when we receive it (down to the teeniest fraction of an inch) and professionally frame it.`, url: `https://app.printframeco.com/7d429f87-2a94-4dcc-b3d1-ab9c38c2cae2/DropOff.jpg` },
              ]
            },
            {
              name: 'Textiles & T-shirts',
              icon: `https://cdn.framebridge.com/production/art_type_tiles/2/icons/original/prints_vector.svg?1599587696`,
              value: 'clothing',
              description: `We'll recommend specific frames.`,
              services: [
                { name: 'Frame In Store - Drop Off & Collection', value: 'instore', description: `Drop your art in at our store. Our experts will meticulously measure your piece when we receive it (down to the teeniest fraction of an inch) and professionally frame it.`, url: `https://app.printframeco.com/7d429f87-2a94-4dcc-b3d1-ab9c38c2cae2/DropOff.jpg` },
              ]
            },
            {
              name: 'Objects & Anything With Depth',
              icon: `https://cdn.framebridge.com/production/art_type_tiles/2/icons/original/prints_vector.svg?1599587696`,
              value: 'object',
              description: `We'll recommend specific frames with depth.`,
              services: [
                { name: 'Frame In Store - Drop Off & Collection', value: 'instore', description: `Drop your art in at our store. Our experts will meticulously measure your piece when we receive it (down to the teeniest fraction of an inch) and professionally frame it.`, url: `https://app.printframeco.com/7d429f87-2a94-4dcc-b3d1-ab9c38c2cae2/DropOff.jpg` }
              ]
            },
          ]
        },
      ],
    },
    /*{
      name: "Extras",
      icon: svgpalette,
      description:
        "Customise the design of the star map such as the background colour or elements displayed on the star map.",
      variants: [
      ],
    },*/
  ],
};

//Update frame overlay
function updateframeoverlay() {
  if (cache.frame) {
    let selectedFrame = cache.frame.id;

    let selectedratio = cache.dims.width / cache.dims.height;
    console.log("selectedratio: " + selectedratio);

    let findClosest = framejson.reduce(function (prev, curr) {
      let prevratio = (function () {
        let ratio;
        for (let obj of framejson) {
          if (obj.size == prev.size) {
            if (obj.size.indexOf("a") > -1) {
              if (
                obj.size == "a4p" ||
                obj.size == "a3p" ||
                obj.size == "a2p" ||
                obj.size == "a1p"
              ) {
                ratio = 8.27 / 11.69;
              } else if (
                obj.size == "a4l" ||
                obj.size == "a3l" ||
                obj.size == "a2l" ||
                obj.size == "a1l"
              ) {
                ratio = 11.69 / 8.27;
              }
            } else {
              ratio =
                Number(obj.size.split("x")[0]) / Number(obj.size.split("x")[1]);
            }
          }
        }
        return ratio;
      })();

      let currratio = (function () {
        let ratio;
        for (let obj of framejson) {
          if (obj.size == curr.size) {
            if (obj.size.indexOf("a") > -1) {
              if (
                obj.size == "a4p" ||
                obj.size == "a3p" ||
                obj.size == "a2p" ||
                obj.size == "a1p"
              ) {
                ratio = 8.27 / 11.69;
              } else if (
                obj.size == "a4l" ||
                obj.size == "a3l" ||
                obj.size == "a2l" ||
                obj.size == "a1l"
              ) {
                ratio = 11.69 / 8.27;
              }
            } else {
              ratio =
                Number(obj.size.split("x")[0]) / Number(obj.size.split("x")[1]);
            }
          }
        }
        return ratio;
      })();

      return Math.abs(currratio - selectedratio) <
        Math.abs(prevratio - selectedratio)
        ? curr
        : prev;
    });

    let selectedSize = findClosest.size;

    var pageRatio = selectedSize.split("x")[0] / selectedSize.split("x")[1];

    for (var j = 0; j < framejson.length; j++) {
      if (
        selectedSize == framejson[j].size &&
        selectedFrame == framejson[j].frameColour
      ) {
        var imageurl = framejson[j].overlay;
        if (imageurl === "") {
          fabric.Image.fromURL(
            imageurl,
            function (image) {
              canvas.setOverlayImage(null);
              canvas.renderAll();
            },
            { crossOrigin: "anonymous" }
          );

          canvas.setOverlayImage(
            "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/print-frame-co-logo-textonly.png?v=1634587330",
            function () {
              //https://cdn.shopify.com/s/files/1/0272/8512/7220/files/print-frame-co-logo-black_79864e1f-c0d6-4d8e-86a4-8c92c4af668f_300x300.png?v=1597492312
              canvas.overlayImage &&
                canvas.overlayImage.scaleToWidth(canvas.getWidth() / 2);
              canvas.renderAll();
            },
            {
              top: canvas.getHeight() / canvas.getZoom() / 2,
              left: canvas.getWidth() / canvas.getZoom() / 2,
              angle: -45,
              originX: "center",
              originY: "center",
              opacity: 0.05,
              crossOrigin: "Anonymous",
            }
          );
        } else {
          fabric.Image.fromURL(
            imageurl,
            function (image) {
              image.scaleToWidth(canvas.getWidth() / canvas.getZoom());
              image.scaleToHeight(canvas.getHeight() / canvas.getZoom());
              image.set({
                id: "image_frame",
                scaleX: canvas.getWidth() / image.width,
              });
              //canvas.add(image);
              //canvas.setBackgroundImage(image);
              canvas.setOverlayImage(image, canvas.renderAll.bind(canvas));
              canvas.renderAll();
            },
            { crossOrigin: "anonymous" }
          );
        }
      }
    }
  }
}
